/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportGet200Response
 */
export interface ExportGet200Response {
    /**
     * The URL to download the exported CSV file
     * @type {string}
     * @memberof ExportGet200Response
     */
    url?: string;
}

/**
 * Check if a given object implements the ExportGet200Response interface.
 */
export function instanceOfExportGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExportGet200ResponseFromJSON(json: any): ExportGet200Response {
    return ExportGet200ResponseFromJSONTyped(json, false);
}

export function ExportGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function ExportGet200ResponseToJSON(value?: ExportGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

